import { Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import About from "./pages/About";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Kitchens from "./pages/Kitchens";
import KitchenDetail from "./pages/KitchenDetail";
import NotFound from "./pages/NotFound";
/* import Bathrooms from "./pages/Bathrooms";
import BathroomDetail from "./pages/BathroomDetail"; */
import Contacts from "./pages/Contacts";
import Closets from "./pages/Closets";
import ClosetDetail from "./pages/ClosetDetail";

const App = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="relative flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/kitchens" element={<Kitchens />} />
          <Route path="/kitchens/:id" element={<KitchenDetail />} />
          <Route path="/closets" element={<Closets />} />
          <Route path="/closets/:id" element={<ClosetDetail />} />
          {/* <Route path="/bathrooms" element={<Bathrooms />} />
          <Route path="/bathrooms/:id" element={<BathroomDetail />} /> */}
          <Route path="/contacts" element={<Contacts />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
};

export default App;
